// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-3vrDo","link":"link-3-Otr","title":"title-3qqYx","icon":"icon-1q914","multiCity":"multiCity-1j0Qy"};